/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";

const useAnimation = (
  preAnimate,
  animation,
  sctRef,
  animRef,
  isStarted,
  isFinished,
  setIsFinished,
  setIsStarted,
  afterAnimate
) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const mobileResolution = 800;

  const computeExpensiveValue = (resolution, width) => {
    return resolution <= width;
  };
  const memoizedValue = useMemo(
    () => computeExpensiveValue(mobileResolution, windowWidth),
    [mobileResolution, windowWidth]
  );

  const prepareAnimation = () => {
    preAnimate();
    animation().clear();
    animRef.current.classList.add("animation_fixed");
  };

  const startAnimation = () => {
    animation(setIsFinished).play();
  };

  const sctToggle = (ref, condition) => {
    ref.current &&
      ref.current.childNodes.forEach((node, index) => {
        index !== 0 && node.classList.toggle("section-hidden", condition);
      });
  };

  const endAnimation = () => {
    animation().kill();
    sctToggle(sctRef, !isFinished);
    animRef.current.classList.remove("animation_fixed");
    document.body.classList.remove("scrollbar_hidden");
    animRef.current.scrollIntoView();
    afterAnimate();
  };

  useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
    prepareAnimation();
    return () => {
      document.body.classList.remove("scrollbar_hidden");
      window.removeEventListener("resize", () =>
        setWindowWidth(window.innerWidth)
      );
    };
  }, []);

  useEffect(() => {
    if (!isStarted && !isFinished) {
      sctToggle(sctRef, memoizedValue);
      document.body.classList.toggle("scrollbar_hidden", memoizedValue);
      memoizedValue && window.scrollTo({ top: 0 });
    }

    if (!memoizedValue && isStarted) {
      endAnimation();
    }

    sctRef.current.onwheel = () => {
      !isStarted && memoizedValue && setIsStarted(true);
    };
    sctRef.current.ontouchmove = () => {
      !isStarted && memoizedValue && setIsStarted(true);
    };

    return () => {
      isStarted && !isFinished && setIsFinished(true);
    };
  }, [memoizedValue, isFinished, isStarted]);

  useEffect(() => {
    !memoizedValue && window.scrollTo({ top: 0 });
  }, [memoizedValue]);

  useEffect(() => {
    isStarted && startAnimation();
  }, [isStarted]);

  useEffect(() => {
    isFinished && endAnimation();
  }, [isFinished]);
};

export default useAnimation;
